(function() {
  var DRAWER_ROOT_SELECTOR = '#CartDrawerForm';
  var drawerObserver = null;
  var syncTimer = null;
  var langObserver = null;
  var lineItemRetryTimer = null;
  var lineItemLateRetryTimer = null;
  var pendingCartState = null;
  var weglotBootstrapTimer = null;
  var weglotBootstrapAttempts = 0;
  var weglotLanguageHookBound = false;
  var cartMarkupPatched = false;
  var cartDrawerOpenPatched = false;

  function setText(node, value) {
    if (!node) return;
    if (node.textContent !== value) {
      node.textContent = value;
    }
  }

  function setTranslatableText(node, value) {
    if (!node) return;
    setText(node, value);
    setAttribute(node, 'data-ls-source-text', value);
  }

  function setHtml(node, value) {
    if (!node) return;
    if (node.innerHTML !== value) {
      node.innerHTML = value;
    }
  }

  function setAttribute(node, name, value) {
    if (!node) return;
    if (node.getAttribute(name) !== value) {
      node.setAttribute(name, value);
    }
  }

  /* LeStyle cart drawer summary Weglot loop guard v38 */
  function protectCartDrawerSummaryNode(node) {
    if (!node) return;
    node.classList.add('notranslate');
    setAttribute(node, 'data-wg-notranslate', '');
    setAttribute(node, 'translate', 'no');
    setAttribute(node, 'data-ls-cart-summary-stable', '');
  }

  function isCartDrawerSummaryProtectedNode(node) {
    return !!(
      node &&
      node.closest &&
      node.closest('[data-ls-cart-savings-row], .ls-cart-total-row, [data-ls-cart-summary-stable], [data-wg-notranslate], .notranslate, [translate="no"]')
    );
  }

  function setData(node, key, value) {
    if (!node) return;
    if (node.dataset[key] !== value) {
      node.dataset[key] = value;
    }
  }

  function normalizeLang(value) {
    return String(value || '').toLowerCase().split('-')[0];
  }

  function detectUiLang(scope) {
    var lang = '';


    if (!lang && window.location && typeof window.location.pathname === 'string') {
      var first = window.location.pathname.split('/').filter(Boolean)[0] || '';
      if (['es', 'fr', 'it', 'de', 'nl'].indexOf(String(first).toLowerCase()) !== -1) {
        lang = first;
      }
    }

    if (!lang && scope) {
      var shippingRoot = scope.querySelector('[data-ls-cart-shipping]');
      lang = shippingRoot && shippingRoot.getAttribute('data-ui-lang') || '';
    }

    if (!lang && document && document.documentElement) {
      lang = document.documentElement.getAttribute('lang') || '';
    }

    return normalizeLang(lang || 'en');
  }

  var CARRIER_BY_COUNTRY = {
    ES: 'correos',
    FR: 'colissimo',
    IT: 'poste'
  };

  var CARRIER_LABELS = {
    dhl: 'DHL',
    correos: 'Correos',
    colissimo: 'Colissimo',
    poste: 'Poste Italiane'
  };

  function countryNameFor(iso, lang) {
    var safeIso = String(iso || '').toUpperCase();
    var strings = getCartDrawerStrings();
    var countryMap = strings.countryNames || {};

    if (countryMap[safeIso]) {
      return countryMap[safeIso];
    }

    try {
      if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
        var display = new Intl.DisplayNames([normalizeLang(lang || 'en')], { type: 'region' });
        var resolved = display.of(safeIso);
        if (resolved) return resolved;
      }
    } catch (_error) {}

    return safeIso || '';
  }

  function getShippingCopy(lang) {
    void lang;
    var strings = getCartDrawerStrings();
    return strings.shipping || { prefix: '', with: '' };
  }

  var CHECKOUT_CTA_BY_LANG = {
    en: 'Check out',
    es: 'Finalizar pedido',
    fr: 'Procéder au paiement',
    it: 'COMPLETA IL TUO ORDINE',
    de: 'Zur Kasse',
    nl: 'Afrekenen'
  };

  function getCheckoutCtaLabel(lang) {
    var key = normalizeLang(lang || 'en');
    return CHECKOUT_CTA_BY_LANG[key] || CHECKOUT_CTA_BY_LANG.en;
  }

  function getCartDrawerStrings() {
    if (
      window.theme &&
      window.theme.strings &&
      window.theme.strings.cartDrawer
    ) {
      return window.theme.strings.cartDrawer;
    }

    return {};
  }

  function getCartDrawerString(key) {
    var strings = getCartDrawerStrings();
    var value = strings && strings[key];
    return typeof value === 'string' ? value : '';
  }

  function syncCartDrawerCopy(scope) {
    var root = scope || document;
    var savingsLabel = getCartDrawerString('youSave');
    var totalLabel = getCartDrawerString('total');

    if (savingsLabel) {
      root.querySelectorAll('[data-ls-cart-savings-label]').forEach(function(node) {
        protectCartDrawerSummaryNode(node);
        setText(node, savingsLabel);
        setAttribute(node, 'data-ls-cart-drawer-copy-key', 'youSave');
        setAttribute(node, 'data-ls-source-text', savingsLabel);
      });
    }

    if (totalLabel) {
      root.querySelectorAll('[data-ls-cart-total-label]').forEach(function(node) {
        protectCartDrawerSummaryNode(node);
        setText(node, totalLabel);
        setAttribute(node, 'data-ls-cart-drawer-copy-key', 'total');
        setAttribute(node, 'data-ls-source-text', totalLabel);
      });
    }
  }

  function syncCheckoutCta(scope) {
    var root = scope || document;
    var lang = detectUiLang(root);
    var label = getCheckoutCtaLabel(lang);

    root.querySelectorAll('[data-ls-checkout-button]').forEach(function(button) {
      setAttribute(button, 'aria-label', label);
      button.classList.add('notranslate');
      setAttribute(button, 'data-wg-notranslate', '');
      setAttribute(button, 'translate', 'no');

      var labelNode = button.querySelector('[data-ls-checkout-label]');
      if (!labelNode) return;

      setText(labelNode, label);
      labelNode.classList.add('notranslate');
      setAttribute(labelNode, 'data-wg-notranslate', '');
      setAttribute(labelNode, 'translate', 'no');
    });
  }

  function extractGeoCountry(payload) {
    if (!payload || typeof payload !== 'object') return null;

    var country = null;
    if (payload.detected_values && payload.detected_values.country) {
      country = payload.detected_values.country;
    } else if (payload.country && typeof payload.country === 'object') {
      country = payload.country;
    }

    if (!country) return null;

    var iso = country.handle || country.iso_code || country.code || '';
    if (!iso && typeof country === 'string') {
      iso = country;
    }
    return iso ? String(iso).toUpperCase() : null;
  }

  function applyShipping(scope, countryIso) {
    if (!scope) return;

    var shippingRoot = scope.querySelector('[data-ls-cart-shipping]');
    if (!shippingRoot) return;

    var shippingLogo = scope.querySelector('[data-ls-cart-shipping-logo]');
    var shippingText = scope.querySelector('[data-ls-cart-shipping-text]');
    var shippingPrefix = scope.querySelector('[data-ls-cart-shipping-prefix]');
    var shippingDestination = scope.querySelector('[data-ls-cart-shipping-destination]');
    var shippingWith = scope.querySelector('[data-ls-cart-shipping-with]');
    var shippingCarrier = scope.querySelector('[data-ls-cart-shipping-carrier]');
    var shippingLogos = scope.querySelector('[data-ls-cart-shipping-logos]');

    var safeIso = String(countryIso || shippingRoot.getAttribute('data-country-iso') || 'GB').toUpperCase();
    var lang = detectUiLang(scope);
    var copy = getShippingCopy(lang);
    var carrierKey = CARRIER_BY_COUNTRY[safeIso] || 'dhl';
    var carrierLabel = CARRIER_LABELS[carrierKey] || CARRIER_LABELS.dhl;
    var countryName = countryNameFor(safeIso, lang);

    setAttribute(shippingRoot, 'data-country-iso', safeIso);
    setAttribute(shippingRoot, 'data-country-name', countryName);
    setAttribute(shippingRoot, 'data-carrier-key', carrierKey);
    setAttribute(shippingRoot, 'data-ls-current-carrier', carrierKey);
    setAttribute(shippingRoot, 'data-ui-lang', lang);
    if (shippingLogo) {
      shippingLogo.classList.add('notranslate');
      setAttribute(shippingLogo, 'data-wg-notranslate', '');
      setAttribute(shippingLogo, 'translate', 'no');
      setAttribute(shippingLogo, 'data-ls-current-carrier', carrierKey);
    }
    if (shippingLogos) {
      shippingLogos.classList.add('notranslate');
      setAttribute(shippingLogos, 'data-wg-notranslate', '');
      setAttribute(shippingLogos, 'translate', 'no');
    }
    setText(shippingPrefix, copy.prefix);
    setText(shippingDestination, countryName);
    setText(shippingWith, copy.with);
    setText(shippingCarrier, carrierLabel);

    if (shippingLogo && shippingLogos) {
      var template = shippingLogos.querySelector('template[data-carrier-template="' + carrierKey + '"]');
      if (template) {
        setHtml(shippingLogo, template.innerHTML);
      }
    }

    requestWeglot(shippingRoot);
  }

  function syncShipping(scope) {
    if (!scope || !scope.querySelector('[data-ls-cart-shipping]')) {
      return;
    }

    applyShipping(scope);

    fetch('/browsing_context_suggestions.json', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('geo_lookup_failed');
        return response.json();
      })
      .then(function(payload) {
        var iso = extractGeoCountry(payload);
        if (iso) {
          applyShipping(scope, iso);
        }
      })
      .catch(function() {});
  }

  function parseMoneyToCents(value) {
    var raw = String(value || '').trim();
    if (!raw) return null;

    var normalized = raw.replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
    if (!normalized) return null;

    var lastComma = normalized.lastIndexOf(',');
    var lastDot = normalized.lastIndexOf('.');
    var decimalIndex = Math.max(lastComma, lastDot);
    var intPart = '';
    var fracPart = '';
    var negative = normalized.indexOf('-') !== -1;

    if (decimalIndex >= 0) {
      intPart = normalized.slice(0, decimalIndex).replace(/[^0-9]/g, '');
      fracPart = normalized.slice(decimalIndex + 1).replace(/[^0-9]/g, '').slice(0, 2);
    } else {
      intPart = normalized.replace(/[^0-9]/g, '');
    }

    if (!intPart) intPart = '0';
    while (fracPart.length < 2) fracPart += '0';

    var cents = parseInt(intPart, 10) * 100 + parseInt(fracPart || '0', 10);
    if (!isFinite(cents)) return null;
    return negative ? -cents : cents;
  }

  function inferNumberSeparators(referenceNumber) {
    var sample = String(referenceNumber || '');
    var lastComma = sample.lastIndexOf(',');
    var lastDot = sample.lastIndexOf('.');

    if (lastComma >= 0 && lastDot >= 0) {
      return lastComma > lastDot ? { decimal: ',', thousand: '.' } : { decimal: '.', thousand: ',' };
    }

    if (lastComma >= 0) {
      return { decimal: ',', thousand: '.' };
    }

    return { decimal: '.', thousand: ',' };
  }

  function addThousands(value, separator) {
    return String(value || '').replace(/\B(?=(\d{3})+(?!\d))/g, separator || ',');
  }

  function formatMoneyByReference(cents, referenceText) {
    var safeCents = Math.max(0, parseInt(cents, 10) || 0);
    var lang = getActiveLanguage();
    var locale = lang === 'fr' ? 'fr-FR' : lang === 'es' ? 'es-ES' : lang === 'it' ? 'it-IT' : 'en-GB';

    if (window.Intl && typeof window.Intl.NumberFormat === 'function') {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(safeCents / 100);
      } catch (_error) {}
    }

    var reference = String(referenceText || '').trim();
    var numberMatch = reference.match(/-?[0-9][0-9\s.,]*/);
    var referenceNumber = numberMatch ? String(numberMatch[0] || '') : '';
    var separators = inferNumberSeparators(referenceNumber);
    var prefix = '€';
    var suffix = '';

    if (numberMatch) {
      var start = numberMatch.index || 0;
      var end = start + referenceNumber.length;
      prefix = reference.slice(0, start).trim() || prefix;
      suffix = reference.slice(end).trim();
    }

    var whole = Math.floor(safeCents / 100);
    var centsPart = String(safeCents % 100).padStart(2, '0');
    var amount = addThousands(String(whole), separators.thousand) + separators.decimal + centsPart;

    if (prefix) {
      return prefix + amount + (suffix ? ' ' + suffix : '');
    }

    if (suffix) {
      return amount + ' ' + suffix;
    }

    return amount;
  }

  var LS_SHIPPING_SUMMARY_COPY = {
    en: { label: 'Shipping', value: 'FREE' },
    it: { label: 'Spedizione', value: 'GRATIS' },
    fr: { label: 'Livraison', value: 'Gratuite' },
    es: { label: 'Envío', value: 'GRATIS' },
    de: { label: 'Versand', value: 'KOSTENLOS' },
    nl: { label: 'Verzending', value: 'GRATIS' }
  };

  function getShippingSummaryCopy() {
    var lang = detectUiLang(document);
    return LS_SHIPPING_SUMMARY_COPY[lang] || LS_SHIPPING_SUMMARY_COPY.en;
  }

  function protectShippingSummaryNode(node) {
    if (!node) return;
    node.classList.add('notranslate');
    setAttribute(node, 'data-wg-notranslate', '');
    setAttribute(node, 'translate', 'no');
    setAttribute(node, 'data-ls-cart-summary-stable', '');
  }

  function ensureShippingSummaryRow(drawer, totalRow) {
    var footer = drawer && drawer.querySelector('.drawer__footer');
    if (!footer || !totalRow) return null;

    var row = footer.querySelector('[data-ls-cart-shipping-row]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'cart__item-sub cart__item-row ls-cart-shipping-row notranslate';
      row.setAttribute('data-ls-cart-shipping-row', '');
      row.setAttribute('data-wg-notranslate', '');
      row.setAttribute('translate', 'no');

      var label = document.createElement('div');
      label.className = 'ls-cart-shipping-label notranslate';
      label.setAttribute('data-ls-cart-shipping-label', '');
      protectShippingSummaryNode(label);

      var value = document.createElement('div');
      value.className = 'ls-cart-shipping-value notranslate';
      value.setAttribute('data-ls-cart-shipping-value', '');
      protectShippingSummaryNode(value);

      row.appendChild(label);
      row.appendChild(value);
      footer.insertBefore(row, totalRow);
    }

    protectShippingSummaryNode(row);
    protectShippingSummaryNode(row.querySelector('[data-ls-cart-shipping-label], .ls-cart-shipping-label'));
    protectShippingSummaryNode(row.querySelector('[data-ls-cart-shipping-value], .ls-cart-shipping-value'));
    return row;
  }

  function syncShippingSummaryRow(drawer) {
    if (!drawer) return;
    var totalRow = drawer.querySelector('.ls-cart-total-row');
    var row = ensureShippingSummaryRow(drawer, totalRow);
    if (!row) return;

    var copy = getShippingSummaryCopy();
    setText(row.querySelector('[data-ls-cart-shipping-label], .ls-cart-shipping-label'), copy.label);
    setText(row.querySelector('[data-ls-cart-shipping-value], .ls-cart-shipping-value'), copy.value);
    if (totalRow && row.nextElementSibling !== totalRow) {
      totalRow.parentNode.insertBefore(row, totalRow);
    }
  }

  function ensureSavingsRow(drawer, totalRow) {
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer || !totalRow) return null;

    var row = footer.querySelector('[data-ls-cart-savings-row]');
    if (row) return row;

    row = document.createElement('div');
    row.className = 'cart__item-sub cart__item-row ls-cart-savings-row notranslate';
    row.setAttribute('data-ls-cart-savings-row', '');
    row.setAttribute('data-wg-notranslate', '');
    row.setAttribute('translate', 'no');

    var label = document.createElement('div');
    label.className = 'ls-cart-savings-label notranslate';
    label.setAttribute('data-ls-cart-savings-label', '');
    label.setAttribute('data-ls-cart-drawer-copy-key', 'youSave');
    protectCartDrawerSummaryNode(label);

    var value = document.createElement('div');
    value.className = 'ls-cart-savings-value notranslate';
    value.setAttribute('data-ls-cart-savings-value', '');
    protectCartDrawerSummaryNode(value);

    row.appendChild(label);
    row.appendChild(value);
    footer.insertBefore(row, totalRow);
    return row;
  }

  /* LeStyle cart drawer discount preview guard v27 */
  function cartDrawerDiscountDebugEnabled() {
    try {
      return /[?&]lsCartDebug=1\b/.test(window.location.search || '') || window.localStorage.getItem('lsCartDebug') === '1';
    } catch (_error) {
      return false;
    }
  }

  function cartDrawerDiscountWarn(reason, payload) {
    if (!cartDrawerDiscountDebugEnabled() || !window.console || typeof window.console.warn !== 'function') return;
    window.console.warn('[LeStyle cart drawer discount preview]', reason, payload || {});
  }

  function hideSavingsRow(row, valueNode) {
    if (!row) return;
    row.hidden = true;
    row.style.display = 'none';
    if (valueNode) setText(valueNode, '');
  }

  function parseDiscountMoneyToCents(value) {
    var raw = String(value || '').replace(/\u2212/g, '-');
    if (!raw.trim()) return null;

    var matches = raw.match(/-?\s*(?:€|EUR|USD|\$)\s*[0-9][0-9\s.,]*|-?\s*[0-9][0-9\s.,]*\s*(?:€|EUR|USD|\$)/gi);
    if (!matches || !matches.length) return null;

    var cents = parseMoneyToCents(matches[matches.length - 1]);
    if (cents === null || !isFinite(cents)) return null;
    return Math.abs(cents);
  }

/* LeStyle cart drawer discount preview guard v28 */
  var CART_DRAWER_SAVINGS_COPY_BY_LANG = {
    en: 'You save',
    it: 'Risparmi',
    fr: 'Économies',
    es: 'Ahorras'
  };

  function getSavingsLabelForLang() {
    var lang = getActiveLanguage();
    return CART_DRAWER_SAVINGS_COPY_BY_LANG[lang] || getCartDrawerString('youSave') || CART_DRAWER_SAVINGS_COPY_BY_LANG.en;
  }

  function protectSavingsCopyNode(node) {
    if (!node) return;
    node.classList.add('notranslate');
    node.setAttribute('data-wg-notranslate', '');
    node.setAttribute('translate', 'no');
  }

  function protectSavingsRow(row) {
    if (!row) return;
    protectSavingsCopyNode(row);
    protectSavingsCopyNode(row.querySelector('[data-ls-cart-savings-label]'));
    protectSavingsCopyNode(row.querySelector('[data-ls-cart-savings-value]'));
  }

  function cartDrawerDiscountDebugEnabled() {
    try {
      return /[?&]lsCartDebug=1\b/.test(window.location.search || '') || window.localStorage.getItem('lsCartDebug') === '1';
    } catch (_error) {
      return false;
    }
  }

  function cartDrawerDiscountWarn(reason, payload) {
    if (!cartDrawerDiscountDebugEnabled() || !window.console || typeof window.console.warn !== 'function') return;
    window.console.warn('[LeStyle cart drawer discount preview]', reason, payload || {});
  }

  function hideSavingsRow(row, valueNode) {
    if (!row) return;
    row.hidden = true;
    row.style.display = 'none';
    if (valueNode) setText(valueNode, '');
  }

  function parseDiscountMoneyToCents(value) {
    var raw = String(value || '').replace(/\u2212/g, '-');
    if (!raw.trim()) return null;

    var matches = raw.match(/-?\s*(?:€|EUR|USD|\$)\s*[0-9][0-9\s.,]*|-?\s*[0-9][0-9\s.,]*\s*(?:€|EUR|USD|\$)/gi);
    if (!matches || !matches.length) return null;

    var cents = parseMoneyToCents(matches[matches.length - 1]);
    if (cents === null || !isFinite(cents)) return null;
    return Math.abs(cents);
  }

/* LeStyle cart drawer discount preview guard v29 */
  var CART_DRAWER_SAVINGS_COPY_BY_LANG = {
    en: 'You save',
    it: 'Risparmi',
    fr: 'Économies',
    es: 'Ahorras'
  };

  function getSavingsLabelForLang() {
    var lang = getActiveLanguage();
    return CART_DRAWER_SAVINGS_COPY_BY_LANG[lang] || getCartDrawerString('youSave') || CART_DRAWER_SAVINGS_COPY_BY_LANG.en;
  }

  function protectSavingsCopyNode(node) {
    if (!node) return;
    node.classList.add('notranslate');
    node.setAttribute('data-wg-notranslate', '');
    node.setAttribute('translate', 'no');
  }

  function protectSavingsRow(row) {
    if (!row) return;
    protectSavingsCopyNode(row);
    protectSavingsCopyNode(row.querySelector('[data-ls-cart-savings-label]'));
    protectSavingsCopyNode(row.querySelector('[data-ls-cart-savings-value]'));
  }

  function cartDrawerDiscountDebugEnabled() {
    try {
      return /[?&]lsCartDebug=1\b/.test(window.location.search || '') || window.localStorage.getItem('lsCartDebug') === '1';
    } catch (_error) {
      return false;
    }
  }

  function cartDrawerDiscountWarn(reason, payload) {
    if (!cartDrawerDiscountDebugEnabled() || !window.console || typeof window.console.warn !== 'function') return;
    window.console.warn('[LeStyle cart drawer discount preview]', reason, payload || {});
  }

  function hideSavingsRow(row, valueNode) {
    if (!row) return;
    row.hidden = true;
    row.style.display = 'none';
    if (valueNode) setText(valueNode, '');
  }

  function parseDiscountMoneyToCents(value) {
    var raw = String(value || '').replace(/\u2212/g, '-');
    if (!raw.trim()) return null;

    var matches = raw.match(/-?\s*(?:€|EUR|USD|\$)\s*[0-9][0-9\s.,]*|-?\s*[0-9][0-9\s.,]*\s*(?:€|EUR|USD|\$)/gi);
    if (!matches || !matches.length) return null;

    var cents = parseMoneyToCents(matches[matches.length - 1]);
    if (cents === null || !isFinite(cents)) return null;
    return Math.abs(cents);
  }

/* LeStyle cart drawer discount preview guard v30 */
  var CART_DRAWER_SAVINGS_COPY_BY_LANG = {
    en: 'You save',
    it: 'Risparmi',
    fr: 'Économies',
    es: 'Ahorras'
  };

  function getSavingsLabelForLang() {
    var lang = getActiveLanguage();
    return CART_DRAWER_SAVINGS_COPY_BY_LANG[lang] || getCartDrawerString('youSave') || CART_DRAWER_SAVINGS_COPY_BY_LANG.en;
  }

  function protectSavingsCopyNode(node) {
    if (!node) return;
    node.classList.add('notranslate');
    node.setAttribute('data-wg-notranslate', '');
    node.setAttribute('translate', 'no');
  }

  function protectSavingsRow(row) {
    if (!row) return;
    protectSavingsCopyNode(row);
    protectSavingsCopyNode(row.querySelector('[data-ls-cart-savings-label]'));
    protectSavingsCopyNode(row.querySelector('[data-ls-cart-savings-value]'));
  }

  function cartDrawerDiscountDebugEnabled() {
    try {
      return /[?&]lsCartDebug=1\b/.test(window.location.search || '') || window.localStorage.getItem('lsCartDebug') === '1';
    } catch (_error) {
      return false;
    }
  }

  function cartDrawerDiscountWarn(reason, payload) {
    if (!cartDrawerDiscountDebugEnabled() || !window.console || typeof window.console.warn !== 'function') return;
    window.console.warn('[LeStyle cart drawer discount preview]', reason, payload || {});
  }

  function hideSavingsRow(row, valueNode) {
    if (!row) return;
    row.hidden = true;
    row.style.display = 'none';
    if (valueNode) setText(valueNode, '');
  }

  function parseDiscountMoneyToCents(value) {
    var raw = String(value || '').replace(/\u2212/g, '-');
    if (!raw.trim()) return null;

    var matches = raw.match(/-?\s*(?:€|EUR|USD|\$)\s*[0-9][0-9\s.,]*|-?\s*[0-9][0-9\s.,]*\s*(?:€|EUR|USD|\$)/gi);
    if (!matches || !matches.length) return null;

    var cents = parseMoneyToCents(matches[matches.length - 1]);
    if (cents === null || !isFinite(cents)) return null;
    return Math.abs(cents);
  }

function computeDrawerSavingsCents(drawer) {
    var totalSavings = 0;

    drawer.querySelectorAll('.cart__item').forEach(function(item) {
      var strikeNode = item.querySelector('.cart__price--strikethrough');
      var nowNode = item.querySelector('.cart__price.cart__discount');
      if (!strikeNode || !nowNode) return;

      var strikeCents = parseMoneyToCents(strikeNode.textContent);
      var nowCents = parseMoneyToCents(nowNode.textContent);
      if (strikeCents === null || nowCents === null || strikeCents <= nowCents) return;

      var qtyNode = item.querySelector('.js-qty__num');
      var qty = parseInt((qtyNode && qtyNode.value) || item.getAttribute('data-qty') || '1', 10);
      if (!isFinite(qty) || qty < 1) qty = 1;

      var itemSavings = (strikeCents - nowCents) * qty;
      if (isFinite(itemSavings) && itemSavings > 0) {
        totalSavings += itemSavings;
      }
    });

    drawer.querySelectorAll('[data-discounts] .cart__discount').forEach(function(node) {
      var discountCents = parseDiscountMoneyToCents(node.textContent);
      if (discountCents === null) return;
      totalSavings += discountCents;
    });

    totalSavings = Math.round(totalSavings);
    return isFinite(totalSavings) && totalSavings > 0 ? totalSavings : 0;
  }


  /* LeStyle localized discount title guard v31 */
  var CART_DRAWER_DISCOUNT_TITLE_BY_LANG = {
    fr: {
      '10% OFF': '10 % de réduction',
      '15% OFF': '15 % de réduction',
      '20% OFF': '20 % de réduction'
    },
    it: {
      '10% OFF': '10% di sconto',
      '15% OFF': '15% di sconto',
      '20% OFF': '20% di sconto'
    },
    es: {
      '10% OFF': '10% de descuento',
      '15% OFF': '15% de descuento',
      '20% OFF': '20% de descuento'
    }
  };

  function localizeCartDiscountTitles(drawer) {
    if (!drawer) return;
    var lang = getActiveLanguage();
    var map = CART_DRAWER_DISCOUNT_TITLE_BY_LANG[lang];
    if (!map) return;

    drawer.querySelectorAll('.cart__discount, [data-discounts] .cart__discount').forEach(function(node) {
      var text = String(node.textContent || '');
      var next = text;
      Object.keys(map).forEach(function(sourceTitle) {
        next = next.replace(new RegExp(sourceTitle.replace('%', '\\\\%'), 'g'), map[sourceTitle]);
      });
      if (next !== text) {
        setText(node, next);
        node.classList.add('notranslate');
        node.setAttribute('data-wg-notranslate', '');
        node.setAttribute('translate', 'no');
      }
    });
  }


  /* LeStyle localized discount title guard v32 */
  function localizeCartDiscountTitles(drawer) {
    if (!drawer) return;
    var lang = getActiveLanguage();
    var map = CART_DRAWER_DISCOUNT_TITLE_BY_LANG[lang];
    if (!map) return;

    drawer.querySelectorAll('.cart__discount, [data-discounts] .cart__discount').forEach(function(node) {
      var text = String(node.textContent || '');
      var next = text;
      Object.keys(map).forEach(function(sourceTitle) {
        next = next.split(sourceTitle).join(map[sourceTitle]);
      });
      if (next !== text) {
        setText(node, next);
        node.classList.add('notranslate');
        node.setAttribute('data-wg-notranslate', '');
        node.setAttribute('translate', 'no');
      }
    });
  }


  /* LeStyle drawer savings euro prefix guard v33 */
  function formatEuroPrefixForDrawer(cents, referenceText) {
    var safeCents = Math.max(0, parseInt(cents, 10) || 0);
    var reference = String(referenceText || '').trim();
    var numberMatch = reference.match(/-?[0-9][0-9\s.,]*/);
    var referenceNumber = numberMatch ? String(numberMatch[0] || '') : '0,00';
    var separators = inferNumberSeparators(referenceNumber);
    var whole = Math.floor(safeCents / 100);
    var centsPart = String(safeCents % 100).padStart(2, '0');
    var amount = addThousands(String(whole), separators.thousand) + separators.decimal + centsPart;
    return '€' + amount;
  }

  function formatSavingsAmountForDrawer(cents, referenceText) {
    var formatted = formatEuroPrefixForDrawer(cents, referenceText);
    return formatted ? '-' + formatted : '';
  }


  /* LeStyle compact drawer discount label guard v35 */
  var CART_DRAWER_COMPACT_DISCOUNT_LABELS_BY_LANG = {
    fr: { '10': 'Remise 10 %', '15': 'Remise 15 %', '20': 'Remise 20 %' },
    it: { '10': 'Sconto 10%', '15': 'Sconto 15%', '20': 'Sconto 20%' },
    es: { '10': 'Dto. 10%', '15': 'Dto. 15%', '20': 'Dto. 20%' }
  };

  function compactCartDrawerLineDiscountLabels(drawer) {
    if (!drawer) return;
    var lang = getActiveLanguage();
    var labels = CART_DRAWER_COMPACT_DISCOUNT_LABELS_BY_LANG[lang];
    if (!labels) return;

    drawer.querySelectorAll('.cart__item-price-col small.cart__discount').forEach(function(node) {
      var text = String(node.textContent || '');
      var match = text.match(/\b(10|15|20)\s*%/);
      if (!match || !labels[match[1]]) return;
      setText(node, labels[match[1]]);
      node.classList.add('notranslate');
      node.setAttribute('data-wg-notranslate', '');
      node.setAttribute('translate', 'no');
    });
  }

  function syncSavingsRow(drawer) {
    if (!drawer) return;

    var totalRow = drawer.querySelector('.ls-cart-total-row');
    if (!totalRow) return;

    var savingsRow = ensureSavingsRow(drawer, totalRow);
    if (!savingsRow) return;
    protectSavingsRow(savingsRow);
    protectCartDrawerSummaryNode(savingsRow);
    protectCartDrawerSummaryNode(totalRow);
    protectCartDrawerSummaryNode(totalRow.querySelector('[data-ls-cart-total-label]'));
    protectCartDrawerSummaryNode(totalRow.querySelector('[data-subtotal]'));

    var labelNode = savingsRow.querySelector('[data-ls-cart-savings-label]');
    var valueNode = savingsRow.querySelector('[data-ls-cart-savings-value]');
    if (!labelNode || !valueNode) return;
    var savingsLabel = getSavingsLabelForLang();
    setText(labelNode, savingsLabel);
    setAttribute(labelNode, 'data-ls-cart-drawer-copy-key', 'youSave');
    setAttribute(labelNode, 'data-ls-source-text', savingsLabel);

    var totalTextNode = totalRow.querySelector('[data-subtotal]') || drawer.querySelector('[data-subtotal]');
    var referenceText = totalTextNode ? totalTextNode.textContent : '';
    var subtotalCents = parseMoneyToCents(referenceText);
    var savingsCents = computeDrawerSavingsCents(drawer);

    if (subtotalCents === null || !isFinite(subtotalCents) || subtotalCents < 0) {
      cartDrawerDiscountWarn('subtotal_unreadable', { subtotalText: referenceText });
      hideSavingsRow(savingsRow, valueNode);
      return;
    }

    if (!(savingsCents > 0)) {
      hideSavingsRow(savingsRow, valueNode);
      return;
    }

    if (!isFinite(savingsCents) || savingsCents > subtotalCents) {
      cartDrawerDiscountWarn('invalid_discount_hidden', {
        savingsCents: savingsCents,
        subtotalCents: subtotalCents,
        subtotalText: referenceText
      });
      hideSavingsRow(savingsRow, valueNode);
      return;
    }

    var formatted = formatSavingsAmountForDrawer(savingsCents, referenceText);
    if (!formatted || /NaN|Infinity|-€0(?:[,.]00)?|€-0/.test(String(formatted))) {
      cartDrawerDiscountWarn('invalid_formatted_discount_hidden', { formatted: formatted });
      hideSavingsRow(savingsRow, valueNode);
      return;
    }

    setText(valueNode, formatted);
    savingsRow.hidden = false;
    savingsRow.style.display = 'flex';
  }

  function protectPaymentBadges(drawer) {
    drawer.querySelectorAll('.ls-checkout-paybadges').forEach(function(list) {
      list.classList.add('notranslate');
      setAttribute(list, 'data-wg-notranslate', '');
      setAttribute(list, 'translate', 'no');
      setAttribute(list, 'aria-hidden', 'true');
      list.removeAttribute('aria-label');

      list.querySelectorAll('.ls-checkout-paybadges__item').forEach(function(item) {
        item.classList.add('notranslate');
        setAttribute(item, 'data-wg-notranslate', '');
        setAttribute(item, 'translate', 'no');
        setAttribute(item, 'aria-hidden', 'true');
      });
    });
  }

  function removeLegacyPromoMarkup(drawer) {
    drawer.querySelectorAll('[data-promo-unlock], .ls-cart-drawer-promo__unlock, .ls-cart-drawer-promo__summary, .ls-cart-drawer-promo__tiers').forEach(function(node) {
      node.remove();
    });
  }

  function requestWeglot(scope) {
    /* Weglot removed; native (T Lab) translations are server-side. */
    return;
  }

  function getActiveLanguage() {

    return String(document.documentElement.lang || 'en').split('-')[0].toLowerCase();
  }


  /* LeStyle drawer option label guard v34 */
  var CART_DRAWER_OPTION_LABELS_BY_LANG = {
    fr: { color: 'Couleur', size: 'Taille' },
    it: { color: 'Colore', size: 'Taglia' },
    es: { color: 'Color', size: 'Talla' },
    de: { color: 'Farbe', size: 'Größe' },
    nl: { color: 'Kleur', size: 'Maat' }
  };

  var CART_DRAWER_COLOR_VALUES_BY_LANG = {
    'apricot': { fr: 'Abricot', it: 'Albicocca', es: 'Albaricoque' },
    'arena': { fr: 'Sable', it: 'Sabbia', es: 'Arena' },
    'army green': { fr: 'Vert militaire', it: 'Verde militare', es: 'Verde militar' },
    'ash gray': { fr: 'Gris cendré', it: 'Grigio cenere', es: 'Gris ceniza' },
    'azure blue': { fr: 'Bleu azur', it: 'Blu azzurro', es: 'Azul celeste' },
    'azul': { fr: 'Bleu', it: 'Blu', es: 'Azul' },
    'beige': { fr: 'Beige', it: 'Beige', es: 'Beige' },
    'black': { fr: 'Noir', it: 'Nero', es: 'Negro' },
    'black-brown': { fr: 'Noir-brun', it: 'Nero-marrone', es: 'Negro-marrón' },
    'blanco': { fr: 'Blanc', it: 'Bianco', es: 'Blanco' },
    'blue': { fr: 'Bleu', it: 'Blu', es: 'Azul' },
    'blue and white': { fr: 'Bleu et blanc', it: 'Blu e bianco', es: 'Azul y blanco' },
    'bordeaux': { fr: 'Bordeaux', it: 'Bordeaux', es: 'Burdeos' },
    'bottle green': { fr: 'Vert bouteille', it: 'Verde bottiglia', es: 'Verde botella' },
    'brown': { fr: 'Marron', it: 'Marrone', es: 'Marrón' },
    'bruin': { fr: 'Marron', it: 'Marrone', es: 'Marrón' },
    'brun': { fr: 'Marron', it: 'Marrone', es: 'Marrón' },
    'brun sienna': { fr: 'Brun sienne', it: 'Marrone siena', es: 'Marrón siena' },
    'cabernet': { fr: 'Cabernet', it: 'Cabernet', es: 'Cabernet' },
    'champagne': { fr: 'Champagne', it: 'Champagne', es: 'Champán' },
    'coal': { fr: 'Charbon', it: 'Carbone', es: 'Carbón' },
    'coffee': { fr: 'Café', it: 'Caffè', es: 'Café' },
    'colorful': { fr: 'Coloré', it: 'Colorato', es: 'Colorido' },
    'cream': { fr: 'Crème', it: 'Crema', es: 'Crema' },
    'creamy white': { fr: 'Blanc crème', it: 'Bianco crema', es: 'Blanco cremoso' },
    'crème': { fr: 'Crème', it: 'Crema', es: 'Crema' },
    'dark blue': { fr: 'Bleu foncé', it: 'Blu scuro', es: 'Azul oscuro' },
    'dark brown': { fr: 'Marron foncé', it: 'Marrone scuro', es: 'Marrón oscuro' },
    'dark gray': { fr: 'Gris foncé', it: 'Grigio scuro', es: 'Gris oscuro' },
    'dark green': { fr: 'Vert foncé', it: 'Verde scuro', es: 'Verde oscuro' },
    'dark grey': { fr: 'Gris foncé', it: 'Grigio scuro', es: 'Gris oscuro' },
    'dark pink': { fr: 'Rose foncé', it: 'Rosa scuro', es: 'Rosa oscuro' },
    'dark red': { fr: 'Rouge foncé', it: 'Rosso scuro', es: 'Rojo oscuro' },
    'earth yellow': { fr: 'Jaune terre', it: 'Giallo terra', es: 'Amarillo tierra' },
    'faded green': { fr: 'Vert délavé', it: 'Verde sbiadito', es: 'Verde descolorido' },
    'fancy white': { fr: 'Blanc fantaisie', it: 'Bianco elegante', es: 'Blanco elegante' },
    'floral': { fr: 'Fleuri', it: 'Floreale', es: 'Floral' },
    'flowery': { fr: 'Fleuri', it: 'Fiorito', es: 'Floral' },
    'fucsia': { fr: 'Fuchsia', it: 'Fucsia', es: 'Fucsia' },
    'gelb': { fr: 'Jaune', it: 'Giallo', es: 'Amarillo' },
    'gold': { fr: 'Doré', it: 'Oro', es: 'Dorado' },
    'gray': { fr: 'Gris', it: 'Grigio', es: 'Gris' },
    'green': { fr: 'Vert', it: 'Verde', es: 'Verde' },
    'green and purple': { fr: 'Vert et violet', it: 'Verde e viola', es: 'Verde y morado' },
    'green water': { fr: 'Vert d’eau', it: 'Verde acqua', es: 'Verde agua' },
    'gris': { fr: 'Gris', it: 'Grigio', es: 'Gris' },
    'gris clair': { fr: 'Gris clair', it: 'Grigio chiaro', es: 'Gris claro' },
    'heavenly blue': { fr: 'Bleu céleste', it: 'Blu celeste', es: 'Azul cielo' },
    'intense pink': { fr: 'Rose vif', it: 'Rosa intenso', es: 'Rosa intenso' },
    'ivory white': { fr: 'Blanc ivoire', it: 'Bianco avorio', es: 'Blanco marfil' },
    'jaune': { fr: 'Jaune', it: 'Giallo', es: 'Amarillo' },
    'khaki': { fr: 'Kaki', it: 'Kaki', es: 'Caqui' },
    'khaki green': { fr: 'Vert kaki', it: 'Verde kaki', es: 'Verde caqui' },
    'lavender blue': { fr: 'Bleu lavande', it: 'Blu lavanda', es: 'Azul lavanda' },
    'lemon yellow': { fr: 'Jaune citron', it: 'Giallo limone', es: 'Amarillo limón' },
    'leopard beige': { fr: 'Beige léopard', it: 'Beige leopardato', es: 'Beige leopardo' },
    'leopard brown': { fr: 'Brun léopard', it: 'Marrone leopardo', es: 'Marrón leopardo' },
    'light blue': { fr: 'Bleu clair', it: 'Azzurro', es: 'Azul claro' },
    'light brown': { fr: 'Marron clair', it: 'Marrone chiaro', es: 'Marrón claro' },
    'light green': { fr: 'Vert clair', it: 'Verde chiaro', es: 'Verde claro' },
    'light pink': { fr: 'Rose pâle', it: 'Rosa chiaro', es: 'Rosa claro' },
    'light purple': { fr: 'Violet clair', it: 'Viola chiaro', es: 'Morado claro' },
    'lilla': { fr: 'Lilas', it: 'Lilla', es: 'Lila' },
    'marina': { fr: 'Bleu marine', it: 'Blu navy', es: 'Azul marino' },
    'marine': { fr: 'Bleu marine', it: 'Blu navy', es: 'Azul marino' },
    'military green': { fr: 'Vert militaire', it: 'Verde militare', es: 'Verde militar' },
    'mint green': { fr: 'Vert menthe', it: 'Verde menta', es: 'Verde menta' },
    'mixed': { fr: 'Mixte', it: 'Misto', es: 'Mixto' },
    'multi': { fr: 'Multicolore', it: 'Multicolore', es: 'Multicolor' },
    'multicolor': { fr: 'Multicolore', it: 'Multicolore', es: 'Multicolor' },
    'multicolored': { fr: 'Multicolore', it: 'Multicolore', es: 'Multicolor' },
    'navy blue': { fr: 'Bleu marine', it: 'Blu navy', es: 'Azul marino' },
    'ocean blue': { fr: 'Bleu océan', it: 'Blu oceano', es: 'Azul océano' },
    'off-white': { fr: 'Blanc cassé', it: 'Bianco sporco', es: 'Blanco roto' },
    'olive': { fr: 'Olive', it: 'Oliva', es: 'Oliva' },
    'orange': { fr: 'Orange', it: 'Arancione', es: 'Naranja' },
    'pastel green': { fr: 'Vert pastel', it: 'Verde pastello', es: 'Verde pastel' },
    'persimmons': { fr: 'Kakis', it: 'Cachi', es: 'Caquis' },
    'photo color': { fr: 'Couleur de la photo', it: 'Colore della foto', es: 'Color de la foto' },
    'pink': { fr: 'Rose', it: 'Rosa', es: 'Rosa' },
    'powder blue': { fr: 'Bleu poudré', it: 'Azzurro polvere', es: 'Azul empolvado' },
    'powder pink': { fr: 'Rose poudré', it: 'Rosa cipria', es: 'Rosa empolvado' },
    'purple': { fr: 'Violet', it: 'Viola', es: 'Morado' },
    'purple with flowers': { fr: 'Violet à fleurs', it: 'Viola con fiori', es: 'Morado con flores' },
    'red': { fr: 'Rouge', it: 'Rosso', es: 'Rojo' },
    'red wine': { fr: 'Rouge vin', it: 'Rosso vino', es: 'Rojo vino' },
    'rojo': { fr: 'Rouge', it: 'Rosso', es: 'Rojo' },
    'rood': { fr: 'Rouge', it: 'Rosso', es: 'Rojo' },
    'rosa': { fr: 'Rose', it: 'Rosa', es: 'Rosa' },
    'rose': { fr: 'Rose', it: 'Rosa', es: 'Rosa' },
    'rose clair': { fr: 'Rose clair', it: 'Rosa chiaro', es: 'Rosa claro' },
    'rosso': { fr: 'Rouge', it: 'Rosso', es: 'Rojo' },
    'rouge': { fr: 'Rouge', it: 'Rosso', es: 'Rojo' },
    'rouge clair': { fr: 'Rouge clair', it: 'Rosso chiaro', es: 'Rojo claro' },
    'rouge passion': { fr: 'Rouge passion', it: 'Rosso passione', es: 'Rojo pasión' },
    'royal blue': { fr: 'Bleu royal', it: 'Blu reale', es: 'Azul real' },
    'ruby red': { fr: 'Rouge rubis', it: 'Rosso rubino', es: 'Rojo rubí' },
    'sky blue': { fr: 'Bleu ciel', it: 'Azzurro', es: 'Azul cielo' },
    'slate gray': { fr: 'Gris ardoise', it: 'Grigio ardesia', es: 'Gris pizarra' },
    'taupe': { fr: 'Taupe', it: 'Talpa', es: 'Topo' },
    'turquoise': { fr: 'Turquoise', it: 'Turchese', es: 'Turquesa' },
    'verde': { fr: 'Vert', it: 'Verde', es: 'Verde' },
    'vert clair': { fr: 'Vert clair', it: 'Verde chiaro', es: 'Verde claro' },
    'vert olive': { fr: 'Vert olive', it: 'Verde oliva', es: 'Verde oliva' },
    'violet': { fr: 'Violet', it: 'Viola', es: 'Morado' },
    'violet silk': { fr: 'Soie violette', it: 'Seta viola', es: 'Seda violeta' },
    'violette': { fr: 'Violet', it: 'Viola', es: 'Violeta' },
    'watercolor': { fr: 'Aquarelle', it: 'Acquerello', es: 'Acuarela' },
    'white': { fr: 'Blanc', it: 'Bianco', es: 'Blanco' },
    'whitish green': { fr: 'Vert blanchâtre', it: 'Verde biancastro', es: 'Verde blanquecino' },
    'wine red': { fr: 'Rouge vin', it: 'Rosso vino', es: 'Rojo vino' },
    'yellow': { fr: 'Jaune', it: 'Giallo', es: 'Amarillo' }
  };

  function normalizeCartDrawerOptionText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[:：]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getCartDrawerOptionKey(value) {
    var normalized = normalizeCartDrawerOptionText(value);
    if (['color', 'colour', 'couleur', 'colore', 'farbe', 'kleur'].indexOf(normalized) >= 0) return 'color';
    if (['size', 'taille', 'taglia', 'talla', 'dimensioni', 'cut', 'cuts', 'couper', 'cortar', 'corte', 'format', 'formato', 'taille/coupe', 'große', 'grosse', 'groesse', 'maat', 'schneiden', 'knippen'].indexOf(normalized) >= 0) return 'size';
    return '';
  }

  function getCartDrawerValueOptionKey(node) {
    if (!node) return '';
    var directKey = node.getAttribute && node.getAttribute('data-ls-cart-option-key');
    if (directKey) return directKey;
    var row = node.closest && node.closest('[data-ls-cart-item-variant]');
    var labelNode = row && row.querySelector('[data-ls-cart-item-option-name]');
    return getCartDrawerOptionKey(labelNode && (labelNode.getAttribute('data-ls-cart-option-key') || labelNode.textContent || labelNode.getAttribute('data-ls-source-text')));
  }

  function localizeCartDrawerOptionValues(drawer) {
    if (!drawer) return;
    var lang = getActiveLanguage();
    if (!lang || lang === 'en') return;

    drawer.querySelectorAll('[data-ls-cart-item-option-value]').forEach(function(node) {
      if (getCartDrawerValueOptionKey(node) !== 'color') return;
      var sourceText = String(node.getAttribute('data-ls-source-text') || node.textContent || '').trim();
      var normalized = normalizeCartDrawerOptionText(sourceText).replace(/\s*\((?:almost|nearly)\s+sold\s+out\)\s*$/i, '');
      var translations = CART_DRAWER_COLOR_VALUES_BY_LANG[normalized];
      var translated = translations && translations[lang];
      if (!translated) return;
      setText(node, translated);
      node.classList.add('notranslate');
      setAttribute(node, 'data-wg-notranslate', '');
      setAttribute(node, 'translate', 'no');
      setAttribute(node, 'data-ls-cart-line-item-stable', '');
    });
  }

  function protectCartDrawerLineItemText(drawer) {
    if (!drawer) return;
    localizeCartDrawerOptionValues(drawer);
    drawer.querySelectorAll('[data-ls-cart-item-option-value], [data-ls-cart-item-selling-plan], [data-ls-cart-item-property-value]').forEach(function(node) {
      node.classList.add('notranslate');
      setAttribute(node, 'data-wg-notranslate', '');
      setAttribute(node, 'translate', 'no');
      setAttribute(node, 'data-ls-cart-line-item-stable', '');
    });
  }

  function protectCartDrawerProductName(node) {
    if (!node) return;
    node.classList.add('notranslate');
    setAttribute(node, 'data-wg-notranslate', '');
    setAttribute(node, 'translate', 'no');
    setAttribute(node, 'data-ls-cart-line-item-name-stable', '');
  }

  function localizeCartDrawerOptionLabels(drawer) {
    if (!drawer) return;
    var lang = getActiveLanguage();
    var labels = CART_DRAWER_OPTION_LABELS_BY_LANG[lang];
    if (!labels) return;

    drawer.querySelectorAll('[data-ls-cart-item-option-name]').forEach(function(node) {
      var key = getCartDrawerOptionKey(node.textContent || node.getAttribute('data-ls-source-text') || '');
      var label = key && labels[key];
      if (!label) return;
      setText(node, label + ' :');
      node.classList.add('notranslate');
      setAttribute(node, 'data-wg-notranslate', '');
      setAttribute(node, 'translate', 'no');
      setAttribute(node, 'data-ls-cart-line-item-stable', '');
      setAttribute(node, 'data-ls-cart-option-key', key);
      setAttribute(node, 'data-ls-source-text', label + ' :');
    });
  }

  function translateLineItemContent(drawer) {
    if (
      !drawer ||
      !window.Weglot ||
      window.Weglot.initialized !== true ||
      typeof window.Weglot.translate !== 'function'
    ) {
      return;
    }

    var language = getActiveLanguage();
    if (!language || language === 'en') {
      return;
    }

    var words = [];
    var nodeMap = new Map();
	    drawer.querySelectorAll('[data-ls-source-text]').forEach(function(node) {
	      if (isCartDrawerSummaryProtectedNode(node)) return;
	      if (node.hasAttribute && node.hasAttribute('data-ls-cart-item-name') && node.hasAttribute('data-ls-cart-line-item-name-stable')) return;
	      var sourceText = String(node.getAttribute('data-ls-source-text') || '').trim();
	      if (!sourceText) return;

      if (!nodeMap.has(sourceText)) {
        nodeMap.set(sourceText, []);
        words.push({ w: sourceText });
      }

      nodeMap.get(sourceText).push(node);
    });

    if (!words.length) {
      return;
    }

    var requestToken = String(Date.now()) + ':' + String(Math.random()).slice(2);
    drawer.setAttribute('data-ls-translate-token', requestToken);

    window.Weglot.translate({
      words: words,
      languageTo: language
    }).then(function(translatedWords) {
      if (drawer.getAttribute('data-ls-translate-token') !== requestToken) {
        return;
      }

      if (!Array.isArray(translatedWords)) {
        return;
      }

      translatedWords.forEach(function(translatedText, index) {
        var sourceText = words[index] && words[index].w;
        if (!sourceText) return;
        if (typeof translatedText !== 'string' || !translatedText.trim()) return;

	        var nodes = nodeMap.get(sourceText) || [];
	        nodes.forEach(function(node) {
	          if (node.textContent !== translatedText) {
	            node.textContent = translatedText;
	          }
	          if (node.hasAttribute && node.hasAttribute('data-ls-cart-item-name')) {
	            protectCartDrawerProductName(node);
	          }
	        });
	      });
      localizeCartDrawerOptionValues(drawer);
      localizeCartDrawerOptionLabels(drawer);
    }).catch(function() {});
  }

  function getProgress(type, count) {
    if (type === 'b1g2') {
      if (count <= 0) return 0;
      if (count === 1) return 33.3333;
      if (count === 2) return 66.6667;
      return 100;
    }

    if (count <= 0) return 0;
    if (count === 1) return 16.6667;
    if (count === 2) return 33.3333;
    if (count === 3) return 66.6667;
    return 100;
  }

  function getPendingCount() {
    if (!pendingCartState || typeof pendingCartState.count !== 'number' || isNaN(pendingCartState.count)) {
      return null;
    }

    return pendingCartState.count;
  }

  function getPromoTranslations(language) {
    void language;
    var strings = getCartDrawerStrings();
    return strings.promo || {};
  }

  function getPromoCopy(language, type, count) {
    var t = getPromoTranslations(language);

    if (type === 'b1g2') {
      if (count >= 3) {
        return {
          eyebrow: t.eyebrow,
          status: t.completeB1g2,
          hint: t.applied,
          tiers: t.tiersB1g2
        };
      }

      if (count === 2) {
        return {
          eyebrow: t.eyebrow,
          status: t.addOneB1g2,
          hint: t.applied,
          tiers: t.tiersB1g2
        };
      }

      return {
        eyebrow: t.eyebrow,
        status: t.addTwoB1g2,
        hint: t.applied,
        tiers: t.tiersB1g2
      };
    }

    if (count >= 4) {
      return {
        eyebrow: t.eyebrow,
        status: t.fourTwenty,
        hint: t.bestApplied,
        tiers: t.tiersProgressive
      };
    }

    if (count === 3) {
      return {
        eyebrow: t.eyebrow,
        status: t.threeFifteen,
        hint: t.addOneTwenty,
        tiers: t.tiersProgressive
      };
    }

    if (count === 2) {
      return {
        eyebrow: t.eyebrow,
        status: t.twoTen,
        hint: t.addOneFifteen,
        tiers: t.tiersProgressive
      };
    }

    return {
      eyebrow: t.eyebrow,
      status: t.addOneTen,
      hint: t.applied,
      tiers: t.tiersProgressive
    };
  }

  function syncPromo(drawer) {
    var promo = drawer.querySelector('[data-cart-promo]');
    if (!promo) return;

    var items = drawer.querySelector('.cart__items');
    var pendingCount = getPendingCount();
    var type = (items && items.dataset.promoType) || promo.dataset.promoType || 'progressive';
    var itemsCount = items && items.dataset.count ? parseInt(items.dataset.count, 10) : null;
    var count = pendingCount;

    if (count === null || typeof count === 'undefined') {
      count = itemsCount;
    }

    if (count === null || typeof count === 'undefined') {
      count = parseInt(promo.dataset.promoCount || '0', 10);
    }
    var eyebrow = promo.querySelector('[data-promo-eyebrow]');
    var status = promo.querySelector('[data-promo-status]');
    var hint = promo.querySelector('[data-promo-hint]');
    var tiersLine = promo.querySelector('[data-promo-tiers-line]');
    var progress = promo.querySelector('[data-promo-progress]');

    if (isNaN(count) || count < 0) count = 0;

    setData(promo, 'promoType', type);
    setData(promo, 'promoCount', String(count));
    promo.hidden = count <= 0;

    if (count > 0) {
      var copy = getPromoCopy(getActiveLanguage(), type, count);
      setTranslatableText(eyebrow, copy.eyebrow);
      setTranslatableText(status, copy.status);
      setTranslatableText(hint, copy.hint);
      setTranslatableText(tiersLine, copy.tiers);
    }

    if (progress) {
      var width = String(getProgress(type, count)) + '%';
      if (progress.style.width !== width) {
        progress.style.width = width;
      }
    }

    if (itemsCount !== null && (pendingCount === null || itemsCount === pendingCount)) {
      pendingCartState = null;
    } else if (count <= 0) {
      pendingCartState = null;
    }
  }

  function canUseWeglot() {
    return false;
  }

  function bindWeglotLanguageHook() {
    if (weglotLanguageHookBound || !window.Weglot || typeof window.Weglot.on !== 'function') {
      return false;
    }

    try {
      window.Weglot.on('languageChanged', function() {
        scheduleSync(30);
      });
      weglotLanguageHookBound = true;
      return true;
    } catch (_error) {
      return false;
    }
  }

  function bootstrapWeglot() {
    if (canUseWeglot()) {
      bindWeglotLanguageHook();
      scheduleSync(30);
      if (weglotBootstrapTimer) {
        window.clearTimeout(weglotBootstrapTimer);
        weglotBootstrapTimer = null;
      }
      return;
    }

    if (weglotBootstrapAttempts >= 40) {
      return;
    }

    weglotBootstrapAttempts += 1;
    weglotBootstrapTimer = window.setTimeout(bootstrapWeglot, 250);
  }

  function registerCartLineItemNodes(drawer) {
    if (!drawer || !window.Weglot || window.Weglot.initialized !== true || typeof window.Weglot.addNodes !== 'function') {
      return;
    }

    var seen = new Set();
    var targets = [];

    function push(node) {
      if (!node || seen.has(node)) return;
      if (node.closest && node.closest('[data-ls-cart-line-item-stable], [data-wg-notranslate], .notranslate, [translate="no"]')) return;
      seen.add(node);
      targets.push(node);
    }

    push(drawer.querySelector('[data-products]'));
    drawer.querySelectorAll('.cart__item, [data-ls-cart-item-name], [data-ls-cart-item-variants], [data-ls-cart-item-variant], [data-ls-cart-item-option-name], [data-ls-cart-item-option-value], [data-ls-cart-item-selling-plan], [data-ls-cart-item-properties], [data-ls-cart-item-property-name], [data-ls-cart-item-property-value], [data-ls-cart-remove-link], [data-ls-cart-qty-label]').forEach(push);

    targets.forEach(function(node) {
      try {
        window.Weglot.addNodes(node);
      } catch (_error) {}
    });

    try {
      window.Weglot.addNodes(document.documentElement);
    } catch (_error) {}
  }

  function scheduleLineItemRetries(drawer) {
    if (!drawer) return;

    if (lineItemRetryTimer) {
      window.clearTimeout(lineItemRetryTimer);
    }
    if (lineItemLateRetryTimer) {
      window.clearTimeout(lineItemLateRetryTimer);
    }

    lineItemRetryTimer = window.setTimeout(function() {
      protectCartDrawerLineItemText(drawer);
      localizeCartDrawerOptionLabels(drawer);
      registerCartLineItemNodes(drawer);
      translateLineItemContent(drawer);
      localizeCartDrawerOptionLabels(drawer);
    }, 180);

    lineItemLateRetryTimer = window.setTimeout(function() {
      protectCartDrawerLineItemText(drawer);
      localizeCartDrawerOptionLabels(drawer);
      registerCartLineItemNodes(drawer);
      translateLineItemContent(drawer);
      localizeCartDrawerOptionLabels(drawer);
    }, 900);
  }

  function syncDrawer() {
    var drawer = document.querySelector(DRAWER_ROOT_SELECTOR);
    if (!drawer) return;

    removeLegacyPromoMarkup(drawer);
    protectPaymentBadges(drawer);
    syncCheckoutCta(drawer);
    syncCartDrawerCopy(drawer);
    localizeCartDiscountTitles(drawer);
    compactCartDrawerLineDiscountLabels(drawer);
    syncPromo(drawer);
    syncShipping(drawer);
    protectCartDrawerLineItemText(drawer);
    localizeCartDrawerOptionLabels(drawer);
    registerCartLineItemNodes(drawer);
    translateLineItemContent(drawer);
    localizeCartDrawerOptionLabels(drawer);
    scheduleLineItemRetries(drawer);
    requestWeglot(drawer);
    syncShippingSummaryRow(drawer);
    syncSavingsRow(drawer);

    window.setTimeout(function() {
      localizeCartDiscountTitles(drawer);
      compactCartDrawerLineDiscountLabels(drawer);
      syncShippingSummaryRow(drawer);
      syncSavingsRow(drawer);
    }, 120);
    window.setTimeout(function() {
      localizeCartDiscountTitles(drawer);
      syncShippingSummaryRow(drawer);
      syncSavingsRow(drawer);
    }, 600);
  }

  function syncCartPage() {
    var pageCart = document.querySelector('#CartPageForm') || document.querySelector('form[action*="/cart"]');
    if (!pageCart) return;
    syncCheckoutCta(pageCart);
    syncShipping(pageCart);
    requestWeglot(pageCart);
  }

  function installThemeHooks() {
    if (window.theme && window.theme.CartForm && window.theme.CartForm.prototype && !cartMarkupPatched) {
      var originalCartMarkup = window.theme.CartForm.prototype.cartMarkup;
      if (typeof originalCartMarkup === 'function') {
        window.theme.CartForm.prototype.cartMarkup = function(text) {
          var result = originalCartMarkup.call(this, text);
          scheduleSync(0);
          scheduleSync(120);
          scheduleSync(600);
          return result;
        };
        cartMarkupPatched = true;
      }
    }

    if (window.theme && window.theme.CartDrawer && window.theme.CartDrawer.prototype && !cartDrawerOpenPatched) {
      var originalOpen = window.theme.CartDrawer.prototype.open;
      if (typeof originalOpen === 'function') {
        window.theme.CartDrawer.prototype.open = function() {
          var result = originalOpen.apply(this, arguments);
          scheduleSync(0);
          scheduleSync(120);
          scheduleSync(600);
          return result;
        };
        cartDrawerOpenPatched = true;
      }
    }

    if (!cartMarkupPatched || !cartDrawerOpenPatched) {
      window.setTimeout(installThemeHooks, 250);
    }
  }

  function observeDrawer() {
    if (!drawerObserver) return;

    var root = document.querySelector(DRAWER_ROOT_SELECTOR);
    if (root) {
      drawerObserver.observe(root, { childList: true, subtree: true });
    }
  }

  function runSync() {
    if (syncTimer) {
      window.clearTimeout(syncTimer);
      syncTimer = null;
    }

    if (drawerObserver) {
      drawerObserver.disconnect();
    }

    try {
      syncDrawer();
      syncCartPage();
    } finally {
      observeDrawer();
    }
  }

  function scheduleSync(delay) {
    if (syncTimer) {
      window.clearTimeout(syncTimer);
    }

    syncTimer = window.setTimeout(runSync, typeof delay === 'number' ? delay : 0);
  }

  document.addEventListener('DOMContentLoaded', function() {
    runSync();
    bootstrapWeglot();
    installThemeHooks();

    if (typeof MutationObserver !== 'undefined') {
      drawerObserver = new MutationObserver(function() {
        scheduleSync(16);
      });
      observeDrawer();
    }

    try {
      if (document.documentElement && typeof MutationObserver !== 'undefined') {
        langObserver = new MutationObserver(function() {
          scheduleSync(30);
        });
        langObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['lang']
        });
      }
    } catch (_error) {}
  });

  document.addEventListener('cart:updated', function(event) {
    var detail = event && event.detail ? event.detail : null;
    var cart = detail && detail.cart ? detail.cart : null;
    var nextCount = cart && typeof cart.item_count === 'number' ? cart.item_count : parseInt(cart && cart.item_count, 10);

    if (!isNaN(nextCount)) {
      pendingCartState = {
        count: Math.max(nextCount, 0)
      };
    }

    scheduleSync(60);
  });
  document.addEventListener('ajaxProduct:added', function() {
    scheduleSync(60);
  });
})();
